"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_library_1 = require("@seneca/client-library");
class SchoolInfoBySchoolIdDoesNotExistError extends client_library_1.ExtendableError {
    constructor(schoolId) {
        super(`School info does not exist for schoolId: ${schoolId}`);
        this.schoolId = schoolId;
    }
}
exports.default = SchoolInfoBySchoolIdDoesNotExistError;
//# sourceMappingURL=SchoolInfoBySchoolIdDoesNotExistError.js.map